import ajax from './http'

const carServer = {
  // 加入购物车
  addCarList(param) {
    return ajax({
      url: '/cart/addCommToCart',
      type: 'post',
      params: param
    })
  },
  // 根据用户id获取购物车信息
  getCarList(param) {
    return ajax({
      url: '/cart/getCartListByUserId',
      type: 'get',
      params: param
    })
  },
  // 根据id列表删除购物车
  deleteCar(param) {
    return ajax({
      url: '/cart/deleteCart',
      type: 'post',
      params: param
    })
  },
  // 编辑购物车
  editCar(param) {
    return ajax({
      url: '/cart/editCart',
      type: 'post',
      params: param
    })
  }
}

export default carServer
